import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import "bootstrap/dist/css/bootstrap.min.css";
import "./modal.css";
import API from "../../../../config";

const ResultModal = props => {
  const closeBtn = props.onHide;
  const setmodalshow = props.setmodalshow;
  const setdownloadmodal = props.setdownloadmodal;
  const setpointmodal = props.setpointmodal;

  const [phoneNumber, setPhoneNumber] = useState("");
  const [name, setName] = useState("");

  const nameValue = e => {
    let originalValue = e.target.value;
    setName(originalValue.trim());
  };

  const phoneNumberValue = e => {
    const originalValue = e.target.value;
    setPhoneNumber(originalValue.trim());
  };

  const submitInfo = async () => {
    // TODO : Quiz 이벤트 포인트 적립을 위한 서버 통신
    const postResponse = await fetch(`${API.auth}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify({ name: name, phone_no: phoneNumber }),
    });
    const post = await postResponse.json();

    if (post.ok) {
      const accessToken = post.result;
      const getResponse = await fetch(`${API.point}`, {
        headers: {
          authorization: "Bearer " + accessToken,
        },
      });

      const get = await getResponse.json();

      setmodalshow(false);

      if (get.ok) {
        setpointmodal(true);
        setdownloadmodal(false);
      } else {
        setpointmodal(false);
        setdownloadmodal(true);
      }
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      animation={false}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          포인트 적립을 위해 <br />
          이름과 핸드폰 번호를 입력해주세요.
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
          <Form.Label>이 름</Form.Label>
          <Form.Control
            type="text"
            value={name}
            onChange={nameValue}
            placeholder="입력해주세요"
            autoFocus
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
          <Form.Label>핸드폰번호</Form.Label>
          <Form.Control
            type="text"
            onChange={phoneNumberValue}
            value={phoneNumber}
            placeholder="입력해주세요"
            maxLength="13"
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => {
            submitInfo();
            setmodalshow(false);
          }}
        >
          포인트 받기
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ResultModal;
